import { MouseEvent } from 'react'
import { Button } from 'antd'
import { ERROR_STATUS } from '@Orders/constants'

import Box from '~/core/Box'
import Tooltip from '~/core/Tooltip'
import styles from '../styles.css'
import { salesOrder_salesOrder_salesOrderLines_items as SalesOrderLineItemType } from '../Queries/__generated__/salesOrder'

import { checkAllErrorsResolved, isSalesOrderLineIdAvailable } from './HTSLogic'

interface HTSFormFooterPropsType {
    pristine: boolean
    errors: {}
    onPreSubmit: Function
    saveAndSubmitLater: Function
    submitting: boolean
    invalid: boolean
    salesOrderLines: SalesOrderLineItemType[]
    selectedValues: {}
    typeOfHts: string
    isAnylineWithProcessName?: boolean
    isHTSSubmissionTimeExpired: boolean
}

export default function HTSFormFooter(props: HTSFormFooterPropsType) {
    const {
        saveAndSubmitLater,
        pristine,
        salesOrderLines,
        selectedValues,
        errors,
        onPreSubmit,
        submitting,
        invalid,
        typeOfHts,
        isAnylineWithProcessName,
        isHTSSubmissionTimeExpired,
    } = props

    const isAllErrorsResolved = checkAllErrorsResolved(errors)
    const isSalesOrderLineIdPresent =
        salesOrderLines &&
        selectedValues &&
        isSalesOrderLineIdAvailable({
            selectedValues,
            typeOfHts,
            salesOrderLines,
        })

    return (
        <Box justifyContent="end">
            <Button
                name="saveAndSubmitLaterBtn"
                onClick={() => {
                    saveAndSubmitLater()
                }}
                disabled={
                    pristine ||
                    !isSalesOrderLineIdPresent ||
                    !isAnylineWithProcessName ||
                    isHTSSubmissionTimeExpired
                }
            >
                Save and finish later
            </Button>
            <Tooltip
                overlayClassName={styles.errorTooltip}
                title={isAllErrorsResolved ? ERROR_STATUS : null}
            >
                <Button
                    type="primary"
                    name="submitBtn"
                    htmlType="submit"
                    disabled={
                        invalid ||
                        !isSalesOrderLineIdPresent ||
                        !isAnylineWithProcessName ||
                        isHTSSubmissionTimeExpired
                    }
                    loading={submitting}
                    style={{
                        marginLeft: 10,
                    }}
                    onClick={(event: MouseEvent<HTMLElement>) =>
                        onPreSubmit(event)
                    }
                >
                    Submit
                </Button>
            </Tooltip>
        </Box>
    )
}
